const calculateTooltipText = (size = 'bodySmall') => {
    let tooltipKind;
    let tooltipSize;
    if (size.includes('body')) {
        tooltipKind = 'body';
        tooltipSize = size
            .replace('body', '')
            .toLocaleLowerCase();
    }
    if (size.includes('title')) {
        tooltipKind = 'title';
        tooltipSize = size
            .replace('title', '')
            .toLocaleLowerCase();
    }
    if (size.includes('feature')) {
        tooltipKind = 'feature';
        tooltipSize = size
            .replace('feature', '')
            .toLocaleLowerCase();
    }
    return {
        tooltipKind,
        tooltipSize,
    };
};

export { calculateTooltipText };
